import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
import Login from '../components/GeneralViews/Login.vue'
// Admin pages
import UserProfile from 'src/components/Dashboard/Views/UserProfile.vue'
import Restaurants from 'src/components/Dashboard/Views/Restaurants.vue'
import Invoice from 'src/components/Dashboard/Views/Invoice.vue'
import InvoiceDetail from 'src/components/Dashboard/Views/InvoiceDetail.vue'
// import SummaryReport from 'src/components/Dashboard/Views/SummaryReport.vue'
import OrderRatings from 'src/components/Dashboard/Views/OrderRatings.vue'
import ErrorsReport from 'src/components/Dashboard/Views/ErrorsReport.vue'
import Support from 'src/components/Dashboard/Views/Support.vue'
import Payments from 'src/components/Dashboard/Views/Payments.vue'
import Dickys from 'src/components/Dashboard/Views/Dickys.vue'
import Seven11 from 'src/components/Dashboard/Views/Seven11.vue'
import Customers from 'src/components/Dashboard/Views/Customers.vue'
import CKE from 'src/components/Dashboard/Views/CKE.vue'
import auth from 'src/auth'

function requireAuth (to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

const routes = [
  {
    path: '/login',
    component: Login
  },
  {
    path: '/',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    redirect: '/login',
    children: [
      {
        path: 'account-settings',
        name: 'Account Settings',
        beforeEnter: requireAuth,
        component: UserProfile
      },
      {
        path: 'invoice-report',
        name: 'Invoice Report',
        beforeEnter: requireAuth,
        component: Invoice
      },
      {
        path: 'invoice-detail',
        name: 'Invoice Detail Report',
        beforeEnter: requireAuth,
        component: InvoiceDetail
      },
      // {
      //   path: 'restaurant-summary',
      //   name: 'Restaurant Summary',
      //   beforeEnter: requireAuth,
      //   component: SummaryReport
      // },
      {
        path: 'payments',
        name: 'Payments',
        beforeEnter: requireAuth,
        component: Payments
      },
      {
        path: 'order-ratings',
        name: 'Order Ratings Report',
        beforeEnter: requireAuth,
        component: OrderRatings
      },
      {
        path: 'errors-report',
        name: 'Errors Report',
        beforeEnter: requireAuth,
        component: ErrorsReport
      },
      {
        path: 'restaurants',
        name: 'Restaurants',
        beforeEnter: requireAuth,
        component: Restaurants
      },
      {
        path: 'support',
        name: 'Support',
        beforeEnter: requireAuth,
        component: Support
      },
      {
        path: 'Dickys',
        name: 'Dickys',
        beforeEnter: requireAuth,
        component: Dickys
      },
      {
        path: 'Seven11',
        name: 'Seven11',
        beforeEnter: requireAuth,
        component: Seven11
      },
      {
        path: 'customers',
        name: 'Customers',
        beforeEnter: requireAuth,
        component: Customers
      },
      {
        path: 'CKE',
        name: 'CKE',
        beforeEnter: requireAuth,
        component: CKE
      },
      {
        path: 'login',
        component: Login
      }
    ]
  },
  {
    path: '/logout',
    beforeEnter (to, from, next) {
      auth.logout()
      next('/')
    }
  },
  {
    path: '*',
    component: NotFound
  }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js